export function utmSourceReducer(state: string | null = null): string | null {
  return state;
}
